<template>
  <b-card title="Edit Discount">
    <b-form @submit.prevent="editDiscount">
      <b-col cols="12" class="mb-1">
        <label>Value(%)<span style="color:red">(*)</span></label>
        <b-form-input
          placeholder="Value(%)"
          type="number"
          v-model="form.value"
          :state="valueState"
          required
        ></b-form-input>
        <b-form-invalid-feedback v-if="valueState === false">
          Value must be between 0 and 100.
        </b-form-invalid-feedback>
      </b-col>

      <b-col cols="12" class="mb-1">
        <label>Status<span style="color:red">(*)</span></label>
        <b-form-select
          v-model="form.status"
          :options="statusOptions"
          required
        ></b-form-select>
      </b-col>

      <b-col v-if="form.status === 'Not General'" cols="12" class="mb-1">
        <label>Email Approval<span style="color:red">(*)</span></label>
        <div v-for="(item, index) in form.emailApproval" :key="index" class="mb-2">
          <b-row class="align-items-center">
            <b-col cols="9">
              <b-form-input
                placeholder="Input Email"
                type="email"
                v-model="form.emailApproval[index]"
                required
              ></b-form-input>
            </b-col>
            <b-col cols="1" class="text-center">
              <b-button
                variant="danger"
                size="sm"
                @click="removeEmailApproval(index)"
                v-if="form.emailApproval.length > 1"
              >
                <feather-icon size="1x" icon="MinusIcon" />
              </b-button>
            </b-col>
            <b-col cols="1" class="text-center">
              <b-button
                variant="primary"
                size="sm"
                @click="addEmailApproval"
                v-if="index === form.emailApproval.length - 1"
              >
                <feather-icon size="1x" icon="PlusIcon" />
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>

      <b-col cols="12" class="mt-2">
        <b-button type="submit" variant="success" :disabled="valueState === false">
          Save
        </b-button>
      </b-col>
    </b-form>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      form: {
        value: 0,
        status: null,
        emailApproval: ['']
      }
    };
  },
  computed: {
    statusOptions() {
      return [
        { value: null, text: 'Please select status' },
        { value: 'General', text: 'General' },
        { value: 'Not General', text: 'Not General' },
      ];
    },
    valueState() {
      return this.form.value >= 0 && this.form.value <= 100;
    }
  },
  methods: {
    editDiscount() {
      if (!this.valueState) return;

      this.$store.dispatch('discount/editDiscount', this.form)
        .then((res) => {
          this.$bvToast.toast('Edit discount success', {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.$router.push('/settings/discount');
        })
        .catch((err) => {
          console.error('Error adding discount:', err);
          this.$bvToast.toast(err.response.data.message, {
            title: "Error",
            variant: "warning",
            solid: true,
          });
        });
    },
    addEmailApproval() {
      this.form.emailApproval.push('');
    },
    removeEmailApproval(index) {
      this.form.emailApproval.splice(index, 1);
    },
  },
  mounted() {
    this.$store.dispatch("discount/fetchDiscountByID", this.$route.params.id)
      .then((data) => {
        this.form = data
        if (data.emailApproval.length === 0) {
          this.form.emailApproval = [''];
        }
      });
  },
};
</script>
